import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  HttpUtilsService,
  LayoutUtilsService,
  QueryParamsModel,
  QueryResultsModel,
} from '../../_base/crud';
import { ActionModel } from '../_models/action.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class ActionService {
  private authToken;
  private company_id;
  private openDialogs: MatDialogRef<any>[] = [];

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private layoutUtils: LayoutUtilsService,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  createAction(_action: ActionModel) {
    const url = `${environment.TIMELINE_BASE}/companies/${this.company_id}/actions`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<any>(url, _action, { headers });
  }

  findActions(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const url = `${environment.TIMELINE_BASE}/companies/${this.company_id}/actions`;
    const params = new HttpParams({
      fromString: ActionService.getActionsListQueryString(queryParams),
    });
    return this.http.get<QueryResultsModel>(url, { params });
  }

  private static getActionsListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&search_term=${filter.searchTerm}`;
    } else {
      if (filter.name) fromString += `&name=${filter.name}`;
      if (filter.type) fromString += `&type=${filter.type}`;
    }

    return fromString;
  }

  updateAction(_action: ActionModel): Observable<any> {
    const url = `${environment.TIMELINE_BASE}/companies/${this.company_id}/actions/${_action.id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.put<ActionModel>(url, _action, { headers });
  }

  searchActions(category_id, search_term) {
    const url = `${environment.TIMELINE_BASE}/companies/${this.company_id}/task_actions`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams()
      .append('sort', 'name,asc')
      .append('category_id', category_id)
      .append('search_term', search_term)
      .append('size', '100');
    return this.http.get<any>(url, { headers, params });
  }

  actionsAutocomplete(search_term) {
    const url = `${environment.TIMELINE_BASE}/companies/${this.company_id}/actions`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams().append('search_term', search_term);
    return this.http.get<any>(url, { headers, params });
  }

  actionsExceptDOCMOSISAutocomplete(search_term) {
    const url = `${environment.TIMELINE_BASE}/companies/${this.company_id}/actions`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams()
      .append('search_term', search_term)
      .append('types', 'EMAIL,FAX,CREATE_TASK,CUSTOM_API');
    return this.http.get<any>(url, { headers, params });
  }

  getCredentialsAutocomplete(search_term) {
    const url = `${environment.NOTIFICATION_BASE}/companies/${this.company_id}/credentials/autocomplete`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams().append('search_term', search_term);
    return this.http.get<any>(url, { headers, params });
  }
  getCredentialByID(credential_id) {
    const url = `${environment.NOTIFICATION_BASE}/companies/${this.company_id}/credentials/${credential_id}`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.get<any>(url, { headers });
  }
  openDialog(dialog, config): MatDialogRef<any> {
    const dialogRef = this.dialog.open(dialog, config);
    this.openDialogs.push(dialogRef);
    return dialogRef;
  }
}
